import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  basicDetails: {
    code: '',
    name: '',
    benefitType: 'OTT',
    status: 'ACTIVE',
    description: '',
    imageUrl: '',
    autoRenew: false,
    providerIds: []
  }
};

export const DigitalServiceSlice = createSlice({
  name: 'digitalService',
  initialState,
  reducers: {
    setBasicDetails: (state, action) => {
      state.basicDetails = { ...state.basicDetails, ...action.payload };
    },
    setField: (state, action) => {
      const { field, value } = action.payload;
      state.basicDetails[field] = value;
    },
    setProviders: (state, action) => {
      state.basicDetails.providerIds = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setBasicDetails,
  setField,
  setProviders,
  reset,
} = DigitalServiceSlice.actions;

export default DigitalServiceSlice.reducer;
